module.exports = __webpack_public_path__ + "static/logo-endo-9a39915ab12d3deb51c5ce3568a0b037.png";